/* eslint-disable react/prop-types */
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

// const appdata = [
//   {
//     type: 'android',
//     image: 'https://cdnstatic.nextias.com/assets/images/icons/googleplay-download.svg',
//     redirectUrl: 'https://play.google.com/store/apps/details?id=com.nextias.app&hl=en_IN&gl=US&pli=1',
//   },
//   {
//     type: 'ios',
//     image: 'https://cdnstatic.nextias.com/assets/images/icons/appstore-download.svg',
//     redirectUrl: 'https://apps.apple.com/in/app/next-ias/id1527559034',
//   },
// ];
// eslint-disable-next-line react/function-component-definition, react/prop-types
const MobileAppList = ({ appdata }) => (
  <div className="flex items-center justify-center fixed bottom-[80px] left-0 right-0 px-4 mx-auto">
    {appdata?.map((data, index) => (
      <Link href={data.redirectUrl} key={data.type} target="__blank" className={` ${index === 0 ? 'mr-4' : ''}`}>
        <Image src={data.image} alt={data.type} width={120} height={30} />
      </Link>
    ))}

  </div>
);

export default MobileAppList;
